if (!window.Eurus.loadedScript.has('confirmation-dyo.js')) {
  window.Eurus.loadedScript.add('confirmation-dyo.js');

  const registerConfirmationDYO = () => {
    Alpine.store('xConfirmationDYO', {
      totalPrice: '',
      page_url: window.location.href,
      type_button: '',
      showLoading: false,
      showCopyMessage: false,
      loadingAddToCart: false,
      dyoData: {
        general: {},
        process: {}
      },
      products: {
        setting: {
        },
        stone: {
          urlProduct: '',
          productVariantSku: '',
          productTitle: '',
          collectionUrl: ''
        }
      },
      call_for_price_item_url: '',
      call_for_price_item_id: '',
      items: [],
      isMissMatch: false,
      show_request_mockup: false,
      total: 0,
      getCollectionHandle(url) {
        return url?.match(/\/collections\/([^/?#]+)/)?.[1] || '';
      },
      async load(shopCurrency) {
        this.total = 0;
        this.items = [];
        this.call_for_price_item_url = '';
        this.call_for_price_item_id = '';
        var params = new URLSearchParams(document.location.search);

        const array = [
          {
            productHandle: params.get('setting_product_handle') || Alpine?.store('xDYO')?.dyoData?.process?.setting?.productHandle, 
            variantId: params.get('setting_variant_id') || Alpine?.store('xDYO')?.dyoData?.process?.setting?.productVariantId
          },
          {
            variantId: params.get('stone_variant_id') || Alpine?.store('xDYO')?.dyoData?.process?.stone?.productVariantId,
            productHandle: params.get('stone_product_handle') || Alpine?.store('xDYO')?.dyoData?.process?.stone?.productHandle,
          }
        ];

        // Always ensure page_url has all DYO parameters
        const currentUrl = new URL(this.page_url);
        const currentParams = new URLSearchParams(currentUrl.search);

        // Set parameters from URL or Alpine store data
        const settingHandle = currentParams.get('setting_product_handle') || array[0]?.productHandle;
        const settingVariantId = currentParams.get('setting_variant_id') || array[0]?.variantId;
        const stoneHandle = currentParams.get('stone_product_handle') || array[1]?.productHandle;

        if (settingHandle && settingVariantId && stoneHandle) {
          // Build URL with all parameters in the correct order
          if (Alpine?.store('xDYO')?.dyoData?.process?.setting?.position == '1') {
            currentParams.set('setting_product_handle', settingHandle);
            currentParams.set('setting_variant_id', settingVariantId);
            currentParams.set('stone_product_handle', stoneHandle);
          } else {
            currentParams.set('stone_product_handle', stoneHandle);
            currentParams.set('setting_product_handle', settingHandle);
            currentParams.set('setting_variant_id', settingVariantId);
          }
          this.page_url = `${currentUrl.origin}${currentUrl.pathname}?${currentParams.toString()}`;
        }


        this.showLoading = true;

        // Build URLs for both products
        const productUrls = array.map((item, i) => {
          const root = window.Shopify?.routes?.root || '/';
          const productUrl = new URL(`${root}products/${item.productHandle}`, window.location.origin);
          if (item.variantId) {
            productUrl.searchParams.set('variant', item.variantId);
          }
          productUrl.searchParams.set('section_id', 'card-product-dyo');
          productUrl.searchParams.set('page', i + 1);
          return `${productUrl.pathname}${productUrl.search}`.replace(/\s+/g, '');
        });

        // Fetch both products in parallel
        const responses = await Promise.all(
          productUrls.map(url => fetch(url).then(res => res.text()).catch(error => {
            console.error('Error fetching:', error);
            return null;
          }))
        );

        // Process results in order (setting first, then stone)
        const parser = new DOMParser();
        for (let i = 0; i < responses.length; i++) {
          if (!responses[i]) continue;

          const responseHtml = parser.parseFromString(responses[i], 'text/html');
          this.setCardData(i, responseHtml);

          const item = {
            variantId: responseHtml.getElementById(`current-variant-id-${i+1}`).textContent,
            productId: responseHtml.getElementById(`current-product-id-${i+1}`).textContent,
            productUrl: responseHtml.getElementById(`current-product-url-${i+1}`).textContent,
            price: responseHtml.getElementById(`current-price-${i+1}`).textContent,
            check_call_for_price: responseHtml.getElementById(`current-product-check-call-for-price-${i+1}`).textContent ? true : false,
            current_variant_title: responseHtml.getElementById(`current-variant-title-${i+1}`).textContent ? true : false,
            handle_collections: responseHtml.getElementById(`dyo-collection-${i+1}`).textContent
          };

          const dataDYO = responseHtml.getElementById(`dyo-data-${i+1}`).textContent;
          let dataDyoJson;
          try {
            // Try to parse as JSON first
            dataDyoJson = JSON.parse(`{${dataDYO}}`);
          } catch (e) {
            try {
              // If JSON parsing fails, use Function constructor for JavaScript object literals
              // This handles single quotes, property names without quotes, and URLs with colons
              dataDyoJson = new Function(`return {${dataDYO}}`)();
            } catch (e2) {
              console.error('Failed to parse DYO data:', dataDYO, e2);
              throw new Error(`Invalid DYO data format: ${e2.message}`);
            }
          }

          if (i == 0) {
            if (this.page_url.includes('?stone_product_handle')) { // Start with stone
              dataDyoJson.position = 2;
            }
            this.setDYOGeneralData(item.handle_collections);
            this.setDYOProcessData('setting', dataDyoJson);
          } else {
            if (this.page_url.includes('?stone_product_handle')) { // Start with stone
              dataDyoJson.position = 1;
            }
            this.setDYOProcessData('stone', dataDyoJson);
            if (params.get('setting_variant_id')) { // If see page with Copy link
              // Add filter param to URL collection process '2'
              if (this.dyoData.process?.setting?.position == '2') {
                this.dyoData.process.setting.urlCollection = Alpine.store('xDYO').getCollectionFilterUrl(
                  'stone',
                  this.getCollectionHandle(this.dyoData.process?.setting?.urlCollection),
                  this.dyoData.process?.stone?.metafields
                );
              }
              if (this.dyoData.process?.stone?.position == '2') {
                this.dyoData.process.stone.urlCollection = Alpine.store('xDYO').getCollectionFilterUrl(
                  'setting',
                  this.getCollectionHandle(this.dyoData.process?.stone?.urlCollection),
                  this.dyoData.process?.setting?.metafields
                );
              }
              Alpine.store('xDYO') && Alpine.store('xDYO').setDyoData('process', this.dyoData.process);
            }
            this.isMissMatch = (Alpine.store('xDYO') && Alpine.store('xDYO').isMissMatch()) || this.isMissMatch;
          }

          this.setTotalPrice(item.price, shopCurrency);
          this.setItems(item);
          this.setProducts(item, i, responseHtml);
        }

        this.renderSettingDisplayProperties();
        this.showLoading = false;
        
        return true;
      },

      //add stone handle and setting handle to the URL  for one second
      addFieldToURL(){
        const params = new URLSearchParams(window.location.search);
        const settingHandle = params.get('setting_product_handle') || Alpine?.store('xDYO')?.dyoData?.process?.setting?.productHandle;
        const stoneHandle = params.get('stone_product_handle') || Alpine?.store('xDYO')?.dyoData?.process?.stone?.productHandle;

        if (settingHandle) {
          params.set('setting_product_handle', settingHandle);
        }
        if (stoneHandle) {
          params.set('stone_product_handle', stoneHandle);
        }

        // Update URL with parameters
        window.history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);

        // After 10 seconds, remove the parameters
        setTimeout(() => {
          window.history.replaceState(null, '', window.location.pathname);
        }, 10000);
      },

      setDYOGeneralData(settingHandle) {
        if (settingHandle) {
          const settingType = settingHandle.split('-').slice(-1)[0] || 'ring';
          const data ={
            "designUrl": Alpine.store('xDYO')?.buildStorefrontPath(`/pages/design-your-own-${settingType}`) || `/pages/design-your-own-${settingType}`,
            "collections": {
              "setting": settingHandle,
              "diamond": `select-a-diamond${settingType == 'earrings' ? '-pair' : ''}`,
              "stone": `select-a-gemstone${settingType == 'earrings' ? '-pair' : ''}`
            },
            "heading": `Design Your Own ${settingType.charAt(0).toUpperCase() + settingType.slice(1)}`
          }
          Alpine.store('xDYO') && Alpine.store('xDYO').setDyoData('general', data)
          this.setDYOData('general', data)
        }
      },
      setDYOData(key, value){
        this.dyoData[key] = value
      },
      setDYOProcessData(key, value){
        this.dyoData.process[key] = value
      },
      getStoredSettingData() {
        return Alpine?.store('xDYO')?.dyoData?.process?.setting || this.dyoData?.process?.setting || {};
      },
      renderSettingDisplayProperties() {
        const variantElement = document.getElementById('variant-1');
        if (!variantElement) return;

        const setting = this.getStoredSettingData();
        const properties = this.getSettingLineProperties(
          setting.rtrSelections,
          setting.ringSize,
          setting.engravingText,
          setting.engravingFont
        );
        delete properties['Bundle ID'];

        const entries = Object.entries(properties).filter(([, value]) => value);
        if (!entries.length) return;

        const fragment = document.createDocumentFragment();
        entries.forEach(([name, value], index) => {
          const line = document.createElement('span');
          line.textContent = `${name}: ${value}`;
          fragment.appendChild(line);
          if (index < entries.length - 1) fragment.appendChild(document.createElement('br'));
        });

        variantElement.replaceChildren(fragment);
      },
      setCardData(index, responseHtml) {
        document.getElementById(`product-card-title-${index+1}`).innerText = responseHtml.getElementById(`product-card-title`).innerText;
        document.getElementById(`product-image-${index+1}`).innerHTML = responseHtml.getElementById(`product-image`).innerHTML;
        document.getElementById(`product-title-${index+1}`).innerText = responseHtml.getElementById(`product-title`).innerText;
        document.getElementById(`variant-${index+1}`).innerText = responseHtml.getElementById(`variant`).innerText;
        document.getElementById(`price-${index+1}`).innerHTML = responseHtml.getElementById(`price`).innerHTML;
        document.getElementById(`current-variant-id-${index+1}`).innerHTML = responseHtml.getElementById(`current-variant-id-${index+1}`).innerHTML;

        // Set product link href from the product URL
        const productLinkElement = document.getElementById(`product-link-${index+1}`);
        const productUrlElement = responseHtml.getElementById(`current-product-url-${index+1}`);
        if (productLinkElement && productUrlElement) {
          productLinkElement.href = productUrlElement.textContent;
        }
      },
      setTotalPrice(price, shopCurrency) {
        if (this.total == 0) {
          this.total += parseFloat(price);
        }
        else {
          this.total += parseFloat(price);
          this.totalPrice = this.formatMoney(this.total, shopCurrency);
        }
      },
      setItems(item) {
        this.items.push({ 
          id: item.variantId,
          product_id: item.productId,
          quantity: 1
        })
      },
      setProducts(item, index, responseHtml) {
        if (item.check_call_for_price && (index != 0 || !this.call_for_price_item_url)) {
          this.call_for_price_item_url = item.productUrl;
          this.call_for_price_item_id = `id-${index+1}`;
          this.type_button = 'call_for_price'
        }
        if (index == 0) {
          // Set setting/jewelry product data
          this.products.setting.urlProduct = item.productUrl;
          const settingSku = responseHtml.getElementById(`current-variant-sku-${index+1}`).textContent;
          this.products.setting.productVariantSku = settingSku || item.variantId;
          this.products.setting.productTitle = responseHtml.getElementById(`current-product-title-${index+1}`).textContent;
          console.log('Setting SKU loaded:', settingSku, 'Using:', this.products.setting.productVariantSku);
        }
        if (index == 1) {
          this.products.stone.urlProduct = item.productUrl;
          const stoneSku = responseHtml.getElementById(`current-variant-sku-${index+1}`).textContent.trim();
          this.products.stone.productVariantSku = stoneSku;
          this.products.stone.productTitle = responseHtml.getElementById(`current-product-title-${index+1}`).textContent;
          this.products.stone.collectionUrl = '/collections/' + item.handle_collections;
          console.log('Stone SKU loaded:', stoneSku, 'Using:', this.products.stone.productVariantSku);
          if (this.isMissMatch) {
            this.type_button = 'get_your_mockup'
          }
          else if (!this.type_button) {
            this.type_button = 'add_to_cart'
          }
        }
      },
      defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      },
      formatWithDelimiters(number, precision, thousands, decimal) {
        precision = this.defaultOption(precision, 2);
        thousands = this.defaultOption(thousands, ',');
        decimal   = this.defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
    
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      },
      formatMoney(amount, formatString) {
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = this.formatWithDelimiters(amount, 2);
            break;
          case 'amount_no_decimals':
            value = this.formatWithDelimiters(amount, 0);
            break;
          case 'amount_with_comma_separator':
            value = this.formatWithDelimiters(amount, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = this.formatWithDelimiters(amount, 0, '.', ',');
            break;
        }
        return formatString.replace(placeholderRegex, value);
      },
      getSettingLineProperties(rtrSelections, ringSize, engravingText, engravingFont, stoneId) {
        const hiddenStoneProperties = new Set([
          'RTR Stone Color',
          'RTR Stone Shape',
          'RTR Carat Size'
        ]);
        const propertyNames = {
          'RTR Metal Type': 'Metal Type',
          'RTR Shank Color': 'Shank Color',
          'RTR Head Color': 'Pongs Color'
        };
        const properties = {};

        if (rtrSelections && typeof rtrSelections === 'object') {
          Object.entries(rtrSelections).forEach(([key, value]) => {
            if (!value || hiddenStoneProperties.has(key)) return;
            properties[propertyNames[key] || key.replace(/^RTR\s+/, '')] = value;
          });
        }

        if (ringSize) properties['Ring Size'] = ringSize;
        if (engravingText?.trim() && engravingFont) {
          properties['Engraving Text'] = engravingText;
          properties['Engraving Font'] = engravingFont;
        }
        if (stoneId) properties['Bundle ID'] = stoneId;

        return properties;
      },
      async handleAddToCart() {
        this.loadingAddToCart = true;
        const settingId = Alpine?.store('xDYO')?.dyoData?.process?.setting?.productVariantId;
        const stoneId = Alpine?.store('xDYO')?.dyoData?.process?.stone?.productVariantId;
        const ringSize = Alpine?.store('xDYO')?.dyoData?.process?.setting?.ringSize; // Use stored ring size
        const engravingText = Alpine?.store('xDYO')?.dyoData?.process?.setting?.engravingText || '';
        const engravingFont = Alpine?.store('xDYO')?.dyoData?.process?.setting?.engravingFont || '';
        const rtrSelections = Alpine?.store('xDYO')?.dyoData?.process?.setting?.rtrSelections;
    
        const dataItems = this.items.reduce((data, product) => {
          data[product.id] ? data[product.id].quantity = 1 : data[product.id] = product;
            
            // Apply 'Ring Size' property only if the product is the ring
            if (product.id == settingId) {
                const settingProperties = this.getSettingLineProperties(
                    rtrSelections,
                    ringSize,
                    engravingText,
                    engravingFont,
                    stoneId
                );
                data[product.id].properties = {
                    ...data[product.id].properties,
                    ...settingProperties
                };
            } else {
                data[product.id].properties = {
                    ...data[product.id].properties, // Preserve other properties
                    'Bundle ID': stoneId
                };
            }
    
            Alpine.store('xConfirmationDYO').ringSize = ringSize;
            Alpine.store('xConfirmationDYO').engravingText = engravingText;
            Alpine.store('xConfirmationDYO').engravingFont = engravingFont;
            return data;
        }, {});

        this.loading = true;

        /* Remove if product exist in cart */
        await fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(async (currentCart) => {
          // Get setting product should remove
          const oldProducts = currentCart?.items?.filter(item => item.id == stoneId || (item.id != settingId && item?.properties?.['Bundle ID'] == stoneId));
          const updates = {};
          oldProducts.forEach(product => {
            updates[product.id] = 0;
          });
          if (Object.keys(updates).length) {
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                updates
              })
            });
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
        

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:  JSON.stringify({ "items": dataItems, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
        }).then((response) => {
          return response.json();
        }).then((response) => {
          Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
            const sectionElement = document.querySelector(section.selector);

            if (sectionElement) {
              if (response.sections[section.id])
                sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
            }
          }));

          //Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          Alpine.store('xMiniCart').reLoad();
          Alpine.store('xMiniCart').open = true;
          Alpine.store('xPopup').open = true;
          document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
          this.loadingAddToCart = false;
        })
      },
      copyLink() {
        const tempInput = document.createElement('textarea');
        tempInput.value = this.page_url;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999);
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        // alert('URL copied to clipboard: ' + this.page_url);
        this.showCopyMessage = true;
        const timeout = setTimeout(() => {
          this.showCopyMessage = false;
          clearTimeout(timeout)
        }, 4000)
      },
      openWhatsapp() {
        const text = `*Hi*+I+want+to+recommend:+${this.page_url}`
        const whatsappUrl = `//wa.me/?text=${text}`;
        window.open(whatsappUrl, '_blank');
      },
      closeRequestMockup() {
        this.show_request_mockup = false;
        Alpine.store('xPopup').open = false;
      },
    });
};

  if (window.Alpine && window.Alpine.version) {
    registerConfirmationDYO();
  } else {
    document.addEventListener('alpine:init', registerConfirmationDYO);
  }
}
